import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import { useFeatureFlags } from "~/providers/FeatureFlagsProvider";
import { OutlinedFlag as OutlinedFlagIcon } from "@mui/icons-material";

export function FeatureFlagsButton() {
  const { isFeatureEnabled, openModal } = useFeatureFlags();

  return isFeatureEnabled("Feature Flags") ? (
    <Tooltip title="Feature Flags">
      <IconButton
        onClick={openModal}
        size="small"
        color="inherit"
        data-name="feature-flags-button"
        aria-label="Feature Flags"
      >
        <OutlinedFlagIcon />
      </IconButton>
    </Tooltip>
  ) : (
    <></>
  );
}
